import { ACTION_TYPES } from "../../actions/catalog/CatalogActions"

const initialState = {
    Supplier: {},
    Status: [],
    ContractServiceCode: []
}
export const CatalogReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTION_TYPES.CLEAN_USER_PROFILE:
            return {
                ...state,
                Supplier: {},
                Status: [],
                ContractServiceCode: []
            }
        case ACTION_TYPES.FETCH_SUPPLIER_BY_ID:
            return {
                ...state,
                Supplier: action.payload
            }
        case ACTION_TYPES.FETCH_STATUS:
            return {
                ...state,
                Status: [...action.payload]
            }
        case ACTION_TYPES.FETCH_CONTRACT_SERVICE_CODE:
            return {
                ...state,
                ContractServiceCode: [...action.payload]
            }
        default:
            return state
    }
}
